var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-field', {
    staticClass: "inputs",
    attrs: {
      "placeholder": _vm.placeholder,
      "label-width": "40",
      "value": _vm.value,
      "type": _vm.ishaspws ? 'text' : 'password'
    },
    on: {
      "input": _vm.setInputValue
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "phone_left_icon"
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/image/ic_pwd.png"),
            "alt": ""
          }
        })])];
      },
      proxy: true
    }, {
      key: "right-icon",
      fn: function () {
        return [_c('div', {
          staticClass: "phone_left_icon"
        }, [_c('img', {
          attrs: {
            "src": _vm.ishaspws ? _vm.onImg : _vm.offImg,
            "alt": ""
          },
          on: {
            "click": function ($event) {
              return _vm.handleSeePaw();
            }
          }
        })])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };